module.exports = __webpack_public_path__ + "img/人物3.f2f595d2.png";